import React, { useState } from 'react';
import { Layout } from '../Layout/Layout';
import { SproutIcon, AtSignIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { UserType } from '../../contexts/UserContext';
export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState<UserType>('farmer');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const {
    login
  } = useUser();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      await login(email, password, userType);
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <Layout data-id="element-88">
      <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center p-4" data-id="element-89">
        <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-xl shadow-lg" data-id="element-90">
          <div className="text-center" data-id="element-91">
            <div className="inline-flex items-center justify-center p-2 bg-leaf-green rounded-full mb-4" data-id="element-92">
              <SproutIcon size={36} className="text-white" data-id="element-93" />
            </div>
            <h2 className="mt-2 text-3xl font-extrabold text-soil-brown" data-id="element-94">
              Sign in to GrowConnect
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-95">
              Access your account to manage agricultural projects and
              investments
            </p>
          </div>
          {error && <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md" data-id="element-96">
              {error}
            </div>}
          <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-97">
            <div className="space-y-4" data-id="element-98">
              <div data-id="element-99">
                <label htmlFor="userType" className="block text-sm font-medium text-gray-700" data-id="element-100">
                  Sign in as
                </label>
                <select id="userType" value={userType || 'farmer'} onChange={e => setUserType(e.target.value as UserType)} className="input-field mt-1" data-id="element-101">
                  <option value="admin" data-id="element-102">GrowConnect Admin</option>
                  <option value="investor" data-id="element-103">Investor</option>
                  <option value="farmer" data-id="element-104">Farmer</option>
                </select>
              </div>
              <div data-id="element-105">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-106">
                  Email address
                </label>
                <div className="relative mt-1" data-id="element-107">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-108">
                    <AtSignIcon size={18} className="text-gray-400" data-id="element-109" />
                  </div>
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="input-field pl-10" placeholder="your.email@example.com" data-id="element-110" />
                </div>
              </div>
              <div data-id="element-111">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-112">
                  Password
                </label>
                <div className="relative mt-1" data-id="element-113">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-114">
                    <LockIcon size={18} className="text-gray-400" data-id="element-115" />
                  </div>
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="input-field pl-10 pr-10" placeholder="••••••••" data-id="element-116" />
                  <button type="button" className="absolute inset-y-0 right-0 flex items-center pr-3" onClick={() => setShowPassword(!showPassword)} data-id="element-117">
                    {showPassword ? <EyeOffIcon size={18} className="text-gray-400" data-id="element-118" /> : <EyeIcon size={18} className="text-gray-400" data-id="element-119" />}
                  </button>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-120">
              <div className="flex items-center" data-id="element-121">
                <input id="remember-me" name="remember-me" type="checkbox" className="w-4 h-4 text-leaf-green border-gray-300 rounded focus:ring-leaf-green" data-id="element-122" />
                <label htmlFor="remember-me" className="block ml-2 text-sm text-gray-700" data-id="element-123">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-124">
                <a href="#" className="font-medium text-leaf-green hover:text-leaf-green/80" data-id="element-125">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-126">
              <button type="submit" className="btn btn-primary w-full" disabled={isLoading} data-id="element-127">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>
          <div className="text-center mt-4" data-id="element-128">
            <p className="text-sm text-gray-600" data-id="element-129">
              Don't have an account?{' '}
              <a href="/register" className="font-medium text-leaf-green hover:text-leaf-green/80" data-id="element-130">
                Sign up
              </a>
            </p>
          </div>
        </div>
      </div>
    </Layout>;
};